import { api } from "./client.js";
import type { ClientFolder, FoldersListResponse } from "@cas/shared";

export const foldersApi = {
  list:    () => api.get<FoldersListResponse>("manage/folders").then(r => r.folders),
  upsert:  (folder: ClientFolder) => api.post<{ folder: ClientFolder }>("manage/folders", { folder }).then(r => r.folder),
  remove:  (domain: string) => api.del<void>(`manage/folders/${encodeURIComponent(domain)}`),
};
